import { Search } from "lucide-react";

const inputCls = "w-full border border-slate-200 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#226DB4]/30 focus:border-[#226DB4] bg-white";

/**
 * FilterBar — unified filter row.
 * Accepts an array of filter config objects:
 *   { type: "search"|"select"|"date"|"month"|"year", key, label, options?, value, onChange }
 *
 * Renders as a horizontal scroll row of compact inputs.
 */
export default function FilterBar({ filters = [], onReset, rightSlot, testid = "filter-bar" }) {
  return (
    <div className="bg-white border border-slate-200 rounded px-4 py-3 flex flex-wrap items-end gap-3" data-testid={testid}>
      {filters.map((f) => (
        <div key={f.key} className="flex-1 min-w-[150px]">
          {f.label && <label className="block text-[11px] uppercase tracking-wider text-slate-500 mb-1">{f.label}</label>}
          {f.type === "search" ? (
            <div className="relative">
              <Search className="absolute left-2 top-2.5 h-4 w-4 text-slate-400" />
              <input
                type="text"
                value={f.value || ""}
                onChange={(e) => f.onChange(e.target.value)}
                placeholder={f.placeholder || "Search…"}
                className={`${inputCls} pl-8`}
                data-testid={`filter-${f.key}`}
              />
            </div>
          ) : f.type === "select" ? (
            <select className={inputCls} value={f.value || ""} onChange={(e) => f.onChange(e.target.value)} data-testid={`filter-${f.key}`}>
              {(f.options || []).map((o) => (
                <option key={String(o.value)} value={o.value}>{o.label}</option>
              ))}
            </select>
          ) : f.type === "date" ? (
            <input type="date" className={inputCls} value={f.value || ""} onChange={(e) => f.onChange(e.target.value)} data-testid={`filter-${f.key}`} />
          ) : f.type === "month" ? (
            <select className={inputCls} value={f.value} onChange={(e) => f.onChange(Number(e.target.value))} data-testid={`filter-${f.key}`}>
              {[1,2,3,4,5,6,7,8,9,10,11,12].map((m) => (
                <option key={m} value={m}>{new Date(2000, m - 1).toLocaleString("default", { month: "long" })}</option>
              ))}
            </select>
          ) : f.type === "year" ? (
            <select className={inputCls} value={f.value} onChange={(e) => f.onChange(Number(e.target.value))} data-testid={`filter-${f.key}`}>
              {[...Array(8)].map((_, i) => {
                const y = new Date().getFullYear() - 2 + i;
                return <option key={y} value={y}>{y}</option>;
              })}
            </select>
          ) : null}
        </div>
      ))}
      <div className="flex items-center gap-2 ml-auto">
        {onReset && <button onClick={onReset} className="px-3 py-2 text-xs text-slate-500 hover:text-slate-700" data-testid="filter-reset">Reset</button>}
        {rightSlot}
      </div>
    </div>
  );
}
